import { Injectable } from '@angular/core';
import { Converter, Occ, Product } from '@spartacus/core';

import { PRODUCT_STOCK_STATUS } from '@siko/constants';
import { SikoB2bOccProduct, SikoB2bProduct, SikoB2bProductDisponibility } from '@siko/models/product.model';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

@Injectable({
   providedIn: 'root',
})
export class SikoProductDisponibilityNormalizer implements Converter<Occ.Product, Product> {
   constructor() {
      dayjs.extend(utc);
   }

   convert(source: SikoB2bOccProduct, target?: SikoB2bProduct): SikoB2bProduct {
      if (target === undefined) target = { ...(source as any) } as SikoB2bProduct;

      target.disponibility = this.normalize(source);

      return target;
   }

   normalize(source: SikoB2bOccProduct): SikoB2bProductDisponibility | undefined {
      if (!source.disponibility) return undefined;

      let disponibility: SikoB2bProductDisponibility = this.normalizeDisponibility(source.disponibility);

      if (source.disponibility.storeDisponibility)
         disponibility.storeDisponibility = this.normalizeDisponibility(source.disponibility.storeDisponibility);

      return disponibility;
   }

   normalizeDisponibility(source: SikoB2bProductDisponibility): SikoB2bProductDisponibility {
      let disponibility: SikoB2bProductDisponibility = { ...(source as any) } as SikoB2bProductDisponibility;

      disponibility.text = this.getStockLevelText(source);

      if (source.status === PRODUCT_STOCK_STATUS.UPCOMING && source.nextDeliveryDate && !source.daysUntilDelivery) {
         const localDate = dayjs(source.nextDeliveryDate).local().startOf('day');
         const currentDate = dayjs().local().startOf('day');
         const daysUntilDelivery = localDate.diff(currentDate, 'day');

         disponibility.daysUntilDelivery = daysUntilDelivery;
      }

      return disponibility;
   }

   getStockLevelText(disponibility: SikoB2bProductDisponibility): string {
      if (!disponibility.status) return '';

      let translationKey = 'siko.disponibility.' + disponibility.status;
      if (disponibility.status === PRODUCT_STOCK_STATUS.UPCOMING && disponibility.nextDeliveryDate) {
         translationKey += 'WithDelivery';
      } else if (disponibility.status === PRODUCT_STOCK_STATUS.ON_ORDER && disponibility.deliveryTime) {
         translationKey += 'WithTime';
      }

      return translationKey;
   }
}
